export { default } from "./NicePic";



// WEBPACK FOOTER //
// ./src/components/NicePic/index.js